import React from 'react';
import * as MUI from '@material-ui/core';
import cn from 'classnames';
import { useStylesSearch } from './styles';
import SearhIcon from '../../../../icons/SearchBlack';

export default ({ ...props }) => {
  const searchClasses = useStylesSearch(props);
  return (
    <MUI.TextField
      {...props}
      placeholder="Quick search"
      InputProps={{
        classes: searchClasses,
        endAdornment: <SearhIcon className={cn(searchClasses.adornedEnd)} />
      }}
    />
  );
}